/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * AirplaneIcon
 */
export default class AirplaneIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20.37 1.326c.152 0 .303.013.45.037a.998.998 0 01.929.238c.09.085.175.175.253.27.099.076.194.158.283.248a1 1 0 01.27.92c.03.146.048.296.053.448l.01.271v.019a4 4 0 01-.858 2.707L19.632 9.17l2.735 6.964a3 3 0 01-.635 3.18l-.149.155a2.343 2.343 0 01-3.489-.132l-4.109-4.956-3.02 3.127.54 2.477a2 2 0 01-.514 1.816l-1.018 1.053a1 1 0 01-1.542-.125L5.69 18.767l-4.054-2.602a1 1 0 01-.18-1.536l1.018-1.054a2 2 0 011.797-.578l2.494.454 3.02-3.128L4.687 6.39a2.343 2.343 0 01-.254-3.482l.1-.103a3 3 0 013.297-.69l7.15 2.936 2.42-2.587a3.593 3.593 0 012.699-1.138h.272zm0 2h-.292a1.605 1.605 0 00-1.218.504l-2.42 2.587a2 2 0 01-2.22.484L7.07 3.964a1 1 0 00-1.099.23l-.1.103a.343.343 0 00.038.51l5.097 3.933a2 2 0 01.217 2.973l-3.02 3.127a2 2 0 01-1.797.578l-2.494-.453-.17.176 2.93 1.879a.996.996 0 01.502.378l-.075-.096c.14.117.242.262.303.422l1.98 2.864.17-.177-.54-2.476a2 2 0 01.515-1.816l3.02-3.128a2 2 0 012.978.113l4.11 4.957a.343.343 0 00.51.019l.149-.155a1 1 0 00.211-1.06l-2.734-6.964a2 2 0 01.294-1.973l2.127-2.686a2 2 0 00.43-1.354l-.003-.039-.01-.293a.707.707 0 00-.036-.2.677.677 0 00-.202-.03z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

